// extracted by mini-css-extract-plugin
export default {"section":"PlansSection_section__a1e-V","sectionHeader":"PlansSection_sectionHeader__Rj5Zc","plans":"PlansSection_plans__Pqia1","sectionBottom":"PlansSection_sectionBottom__fG3ZK"};